const LIVE_PREFIX = 'https://datadesk-prod-origin.californiatimes.com';
const TEST_PREFIX = 'https://elections-2026-backend-dev.s3.amazonaws.com';

export const STATE_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-state.json`;

export const ATTY_GEN_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-ag.json`;

export const BOE_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-BOE.json`;

export const CONTROLLER_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-controller.json`;

export const GOV_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-gov.json`;

export const H_DIST1_UNEXPIRED_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-h-district-1-unexpired.json`;

export const HOUSE_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-house.json`;

export const INSURANCE_COMM_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-insurance-commissioner.json`;

export const LT_GOV_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-lt-gov.json`;

export const SOS_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-sos.json`;

export const STATE_ASSEMBLY_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-state-assembly.json`;

export const STATE_SENATE_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-state-senate.json`;

export const SUE_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-sue.json`;

export const TREASURER_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-treasurer.json`;

export const LA_COUNTY_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/la.json`;

export const LA_MAYOR_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-la-mayor.json`;

export const LB_MAYOR_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-lb-mayor.json`;

export const LA_CC_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-la-city-council.json`;

export const LA_CITY_AAG_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-la-aag-select.json`;

export const LAC_AAG_URL = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-lac-aag-select.json`;

export const SHERIFF = `${LIVE_PREFIX}/projects/elections-data/2026-06-02/latest-lac-sheriff.json`;

export const DROPPED_OUT_CANDIDATES = [
  'polid-62343', // Swalwell / gov
  'polid-105207', // Yee / gov
];

// OTHER
export const GEOGRAPHY_URL =
  'https://datadesk-prod-origin.californiatimes.com/projects/elections-data/2020-11-03/geographies/states/ca.json';
